import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import axios from 'axios';
import getAxiosConfig from "../../../utils/axiosConfig";
import MessageCodes from "../../../utils/messageCodes";
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";
import ToastEnums from "../../Toast/ToastEnums";

class ImportPanel extends Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            loadingImport: false,
            base64ImportContent: "",
            name: "",
            selectedImportOption: "engine"
        };

        this.onImportLogic = this.onImportLogic.bind(this);
        this.onImportFromEngine = this.onImportFromEngine.bind(this);
        this.onImportFromDash = this.onImportFromDash.bind(this);
        this.onImportValueChange = this.onImportValueChange.bind(this);
        this.onNameValueChange = this.onNameValueChange.bind(this);
        this.onOptionChange = this.onOptionChange.bind(this);
    }

    handleGroundClick(e) {
        if (e.target.className === "import-logic-wrapper") {
            this.props.toggleImportPanel();
        }
    }

    onImportValueChange(e) {
        this.setState({
            base64ImportContent: e.target.value
        });
    }

    onOptionChange(e) {
        this.setState({
            selectedImportOption: e.target.value
        });
    }

    onNameValueChange(e) {
        this.setState({
            name: e.target.value
        });
    }

    onImportLogic() {
        this.state.selectedImportOption === "engine" ? this.onImportFromEngine() : this.onImportFromDash();
    }

    onImportFromEngine() {

        let requestBody = {
            logicInBase64: this.state.base64ImportContent,
            userEmail: localStorage.getItem("user"),
            logicName: this.state.name
        };

        this.setState(() => ({loadingImport: true, results: []}), function () {
            axios.post(this.props.properties.logicUrl + "/import/fromEngine", requestBody, getAxiosConfig())
                .then((response) => {
                    this.setState({
                        loadingImport: false
                    });
                    if (response.data.successful) {
                        this.props.onImportFromEngineSuccessful(response.data);
                        this.props.showToastForFrontend(
                            MessageCodes.CUSTOM_TOAST("Successful import", "Logic has been successfully imported", ToastEnums.SUCCESS));
                    } else {
                        this.props.showToastForFrontend(
                            MessageCodes.CUSTOM_TOAST("Incorrect input", "Base64 string is incorrect", ToastEnums.ERROR));
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        this.props.showToastForBackend(err.response.data);
                    } else {
                        this.props.showToastForFrontend(MessageCodes.CONNECTION_ERROR);
                    }
                    this.setState({
                        loadingImport: false
                    });
                });

        });
    }

    onImportFromDash() {
        let requestBody = {
            logicInBase64: this.state.base64ImportContent,
            userEmail: localStorage.getItem("user"),
        };
        this.setState(() => ({loadingImport: true}), function () {
            axios.post(this.props.properties.logicUrl + "/import/fromDash", requestBody, getAxiosConfig())
                .then((response) => {
                    this.setState({
                        loadingImport: false
                    });
                    if (response.data) {
                        this.props.onImportFromDashSuccessful();
                        this.props.showToastForFrontend(
                            MessageCodes.CUSTOM_TOAST("Successful import", "Logic has been successfully imported", ToastEnums.SUCCESS));
                    } else {
                        this.props.showToastForFrontend(
                            MessageCodes.CUSTOM_TOAST("Incorrect input", "Base64 string is incorrect", ToastEnums.ERROR));
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        this.props.showToastForBackend(err.response.data);
                    } else {
                        this.props.showToastForFrontend(MessageCodes.CONNECTION_ERROR);
                    }
                    this.setState({
                        loadingImport: false
                    });
                });

        });
    }

    render() {
        return (
            <div className="import-logic-wrapper" onClick={(e) => this.handleGroundClick(e)}>
                <div className="import-logic">
                    <div className="header">
                        <h2 className="title">Import logic</h2>
                        <button className="action-button" onClick={this.onImportLogic}>
                            <span className="button-label">Import</span>
                            <i
                                className={"material-icons " + (this.state.loadingImport ? "animate" : "")}
                            >upload</i>
                        </button>
                    </div>
                    <div className="content">
                        <div className="import-radio-wrapper">
                            <label className="radio-label">
                                <input type="radio" className="checkbox" value="engine"
                                       checked={this.state.selectedImportOption === "engine"}
                                       onChange={this.onOptionChange} id="engine"/>
                                from engine</label>
                            <label className="radio-label">
                                <input type="radio" className="checkbox" value="dash"
                                       checked={this.state.selectedImportOption === "dash"}
                                       onChange={this.onOptionChange}/>
                                from dash</label>
                        </div>
                        {this.state.selectedImportOption === "engine" &&
                            <FormattedMessage id="Name">
                                {placeholder =>
                                    <input
                                        placeholder={placeholder}
                                        type="text"
                                        name="name"
                                        className="name-input"
                                        onChange={this.onNameValueChange}
                                    />
                                }
                            </FormattedMessage>
                        }
                        <FormattedMessage id="Insert Base64 string here">
                            {placeholder =>
                                <textarea name="importContent"
                                          className="import-textarea"
                                          placeholder={placeholder}
                                          onChange={this.onImportValueChange}/>
                            }
                        </FormattedMessage>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        contextProperties: state.contextProperties
    }
}

export default connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(ImportPanel);